import { CIMSPageItem } from '../CIMSPageItem'
import { Admin } from '../../CIMSModule/instances'

export const Users = new CIMSPageItem({
  id: 'c0c73d42-7783-47fe-ac5e-30f02d543fc0',
  name: 'Users',
  pathname: 'users',
  module: Admin,
  linkable: true,
})
export const Roles = new CIMSPageItem({
  id: '6130b058-2f93-41a6-a344-e35777e08290',
  name: 'Roles',
  pathname: 'roles',
  module: Admin,
})
export const CustomFields = new CIMSPageItem({
  id: 'e3641de6-2548-48b5-97a5-cac769411b6b',
  name: 'Custom Fields',
  pathname: 'custom-fields',
  module: Admin,
})
export const ProjectSettings = new CIMSPageItem({
  id: '3aed6c46-8cf5-4cd3-89ee-0143afac0b9e',
  name: 'Project Settings',
  deprecatedPathnames: ['metadata'],
  pathname: 'project-settings',
  module: Admin,
})
export const NonUserEmails = new CIMSPageItem({
  id: 'd3b52883-ecd4-4de8-b06d-70fa927f442d',
  name: 'Non User Emails',
  pathname: 'non-user-emails',
  module: Admin,
})
export type AdminPageItem =
  | typeof Users
  | typeof Roles
  | typeof CustomFields
  | typeof ProjectSettings
  | typeof NonUserEmails
